import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSafeTranslation } from '../hooks/useSafeTranslation';
import './AppFooter.css';

const AppFooter: React.FC = () => {
  const { t } = useSafeTranslation();
  const year = new Date().getFullYear();

  const stopPlaceholder = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <footer className="app-footer">
      <Container fluid className="app-footer-inner px-2 px-sm-3">
        <div className="app-footer-row">
          <p className="app-footer-copy mb-0">
            © {year} Quizter Club. {t('footer.allRightsReserved', 'All rights reserved.')}
          </p>
          <nav className="app-footer-nav" aria-label={t('footer.navAria', 'Legal information')}>
            <Link to="/about" className="app-footer-link">
              {t('footer.about', 'About')}
            </Link>
            <span className="app-footer-sep" aria-hidden>
              |
            </span>
            <a href="#terms" className="app-footer-link" onClick={stopPlaceholder}>
              {t('footer.terms', 'Terms of Service')}
            </a>
            <span className="app-footer-sep" aria-hidden>
              |
            </span>
            <Link to="/privacy" className="app-footer-link">
              {t('footer.privacy', 'Privacy Policy')}
            </Link>
            <span className="app-footer-sep" aria-hidden>
              |
            </span>
            <Link to="/contact" className="app-footer-link">
              {t('footer.contact', 'Contact')}
            </Link>
            <span className="app-footer-sep" aria-hidden>
              |
            </span>
            <a
              href="https://www.instagram.com/quizterclub/"
              className="app-footer-link app-footer-instagram"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t('footer.instagramAria', 'Quizter Club on Instagram')}
            >
              <i className="bi bi-instagram" aria-hidden />
            </a>
          </nav>
        </div>
      </Container>
    </footer>
  );
};

export default AppFooter;
